// The /signup-confirmation step after a confirm whose first-proof cleanup
// dropped the password set before the proof (server core/auth-takeover-paths
// review r3 D4; Nika: "Ask for a password on confirm"). The person is signed
// in already (the confirm answer's fresh session is stored); this step lets
// them set a password with the single-use `setPasswordToken`, or Skip.
// Painted by the signup-confirmation page while `s.setPasswordToken` is set.
// Same field shape as ResetPasswordsForm; same button control as the sibling
// confirmation panels.
export const ConfirmSetPassword = {
  flow: 'y',
  align: 'center center',
  gap: 'B',
  width: '100%',
  H3: {
    text: '{{ auth.setPassword.title | polyglot }}',
    margin: '0'
  },
  P: {
    text: '{{ auth.setPassword.body | polyglot }}',
    textAlign: 'center',
    color: 'paragraph',
    maxWidth: 'G'
  },
  NewPassword: {
    extends: 'InputField',
    width: '100%',
    Title: { tag: 'span', text: '{{ auth.setPassword.label | polyglot }}' },
    Input: {
      width: '100%',
      theme: 'field',
      background: 'hover',
      minHeight: 'controlH',
      round: 'radiusControl',
      fontSize: 'Z2',
      padding: '0 A',
      type: 'password',
      name: 'new-password',
      autocomplete: 'new-password',
      ariaLabel: (el) => el.call('polyglot', 'auth.setPassword.label'),
      placeholder: (el) => el.call('polyglot', 'auth.setPassword.placeholder'),
      onInput: (ev, el, s) => {
        s.update({ newPassword: el.node.value, setPasswordError: null })
      }
    }
  },
  ErrorNote: {
    tag: 'p',
    role: 'alert',
    margin: '0',
    color: 'dangerInk',
    fontSize: 'Z2',
    // Box reserved; only visibility changes (no layout shift).
    visibility: (el, s) => (s.setPasswordError ? 'visible' : 'hidden'),
    text: '{{ auth.setPassword.error | polyglot }}'
  },
  SaveButton: {
    extends: ['Button', 'ClickableItem'],
    text: '{{ auth.setPassword.save | polyglot }}',
    width: '100%',
    disabled: (el, s) => !s.newPassword || !!s.savingPassword,
    onClick: async (_, el, s) => {
      await el.call('completeConfirmSignIn', s.newPassword || '')
    }
  },
  SkipButton: {
    extends: ['Button', 'ClickableItem'],
    theme: 'transparent',
    text: '{{ auth.setPassword.skip | polyglot }}',
    width: '100%',
    disabled: (el, s) => !!s.savingPassword,
    onClick: async (_, el) => {
      await el.call('completeConfirmSignIn')
    }
  }
}
